import React from 'react';

export default ({ noMargin = false, tiny = false }) => (
    <i
        className={`fa fa-spinner fa-pulse ${tiny ? '' : 'fa-2x'} fa-fw`}
        style={{
            marginTop: noMargin ? 0 : 10,
            marginBottom: noMargin ? 0 : 10,
        }}
    />
);
